const OKButton = require('commons-components/build/OKButton');

module.exports = OKButton;
